<template>
  <div>
    <h2>人気の色</h2>
    <table>
      <tr>
        <!-- <th>順位</th> -->
        <th>選択数</th>
        <th>色</th>
      </tr>
      <!-- <tr v-for="(r, index) in rank" :key="r"> -->
      <tr v-for="(r, index) in rank" :key="index">
        <!-- <td class="right">{{ index+1 }}位</td> -->
        <td class="right">{{ r.selectedCount | addComma }}</td>
        <td><button class="btn" :style="{ backgroundColor: getColorByName(items, r.name).color }" disabled></button></td>
        <td class="left">{{ getColorByName(items, r.name).colorName }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import firebase from "firebase"
export default {
  created() {
    this.counter()
  },
  filters: {
    addComma(value) {
      return value.toLocaleString()
    }
  },
  data() {
    return {
      items: [
        { name: "dp18", color: "rgb(0,66,128)", groups:["sp1","sp2","sp3","sp4"], colorName: "サファイアブルー" },
        { name: "dk6", color: "rgb(121,77,28)", groups:["sp1","sp2","sp3","sp4"], colorName: "くりいろ" },
        { name: "dk16", color: "rgb(0,69,88)", groups:["au1","au2","au3","au4"], colorName: "マリンブルー" },
        { name: "dk18", color: "rgb(18,52,82)", groups:["wi1","wi2","wi3","wi4"], colorName: "ネイビー" },
        { name: "dk20", color: "rgb(50,45,81)", groups:["su1","su2","su3","su4"], colorName: "あおかち" },
        { name: "ltg2", color: "rgb(192,171,170)", groups:["su1","su2","su3","su4"], colorName: "ピンクベージュ" },
        { name: "ltg18", color: "rgb(155,165,175)", groups:["su1","su2","su3","su4"], colorName: "ブルーグレー" },
        { name: "g2", color: "rgb(116,92,92)", groups:["su1","su2","su3","su4"], colorName: "うめねず" },
        { name: "g8", color: "rgb(120,111,87)", groups:["au1","au2","au3","au4"], colorName: "りかんちゃ" },
        { name: "dkg2", color: "rgb(62,45,48)", groups:["wi1","wi2","wi3","wi4"], colorName: "マーリー" },
        { name: "W", color: "rgb(255,255,255)", groups:["wi1","wi2","wi3","wi4"], colorName: "ホワイト" },
        { name: "Gy3.5", color: "rgb(84,84,84)", groups:["wi1","wi2","wi3","wi4"], colorName: "グレー" },
        { name: "BK", color: "rgb(0,0,0)", groups:["wi1","wi2","wi3","wi4"], colorName: "ブラック" },
        { name: "FL4", color: "rgb(240,194,144)", groups:["sp1","sp2","sp3","sp4"], colorName: "サンライト" },
        { name: "FL5", color: "rgb(219,163,107)", groups:["sp4", "au1","au2","au3","au4"], colorName: "アプリコット" },
        { name: "offN1", color: "rgb(251,241,229)", groups:["su1","su2","su3","su4"], colorName: "オフホワイト" },
        { name: "offN2", color: "rgb(243,230,197)", groups:["sp1","sp2","sp3","sp4"], colorName: "アイボリー" },
        { name: "offN4", color: "rgb(245,224,193)", groups:["au1","au2","au3","au4"], colorName: "クリームイエロー" },
        { name: "BR7", color: "rgb(95,80,59)", groups:["au1","au2","au3","au4"], colorName: "こげちゃ" },
        { name: "v1", color: "rgb(185,31,87)", groups:["su4", "wi4"], colorName: "いちごいろ" },
        { name: "v2", color: "rgb(208,47,72)", groups:["su2", "wi1"], colorName: "レッド" },
        { name: "v3", color: "rgb(221,68,59)", groups:["sp3","sp4"], colorName: "スカーレット" },
        { name: "v4", color: "rgb(233,91,35)", groups:["au1","au4"], colorName: "かきいろ" },
        { name: "v5", color: "rgb(230,120,0)", groups:["sp3","sp4", "au1","au4"], colorName: "オレンジ" },
        { name: "v6", color: "rgb(244,157,0)", groups:["sp3","sp4"], colorName: "みかんいろ" },
        { name: "v7", color: "rgb(241,181,0)", groups:["sp3","sp4", "au1"], colorName: "クロームイエロー" },
        { name: "v8", color: "rgb(238,201,0)", groups:["sp3"], colorName: "ジョンブリアン" },
        { name: "v9", color: "rgb(210,193,0)", groups:["wi1"], colorName: "わかくさいろ" },
        { name: "v10", color: "rgb(168,187,0)", groups:["sp3"], colorName: "もえぎ" },
        { name: "v11", color: "rgb(88,169,29)", groups:["sp3","sp4"], colorName: "みどり" },
        { name: "v12", color: "rgb(0,161,90)", groups:["sp3","sp4"], colorName: "エメラルドグリーン" },
        { name: "v13", color: "rgb(0,146,110)", groups:["su4", "wi1"], colorName: "クロームグリーン" },
        { name: "v14", color: "rgb(0,133,127)", groups:["wi4"], colorName: "ビリジアン" },
        { name: "v16", color: "rgb(0,112,155)", groups:["au1"], colorName: "ダックブルー" },
        { name: "v18", color: "rgb(0,91,165)", groups:["su4", "wi1","wi4"], colorName: "コバルトブルー" },
        { name: "v19", color: "rgb(26,84,165)", groups:["su4", "wi1","wi4"], colorName: "オリエンタルブルー" },
        { name: "v20", color: "rgb(83,74,160)", groups:["su4", "wi1","wi4"], colorName: "しおんいろ" },
        { name: "v21", color: "rgb(112,63,150)", groups:["sp3", "su4", "wi1","wi4"], colorName: "すみれいろ" },
        { name: "v22", color: "rgb(129,55,138)", groups:["sp3", "su4", "wi1","wi4"], colorName: "むらさき" },
        { name: "v23", color: "rgb(143,46,124)", groups:["su4", "wi1","wi4"], colorName: "ピアニー" },
        { name: "v24", color: "rgb(173,46,108)", groups:["wi4"], colorName: "マゼンタ" },
        { name: "b2", color: "rgb(239,108,112)", groups:["sp2"], colorName: "コーラルピンク" },
        { name: "b4", color: "rgb(250,129,85)", groups:["sp2"], colorName: "オーロラ" },
        { name: "b6", color: "rgb(255,173,54)", groups:["sp2"], colorName: "ひまわり" },
        { name: "b8", color: "rgb(250,216,49)", groups:["sp2", "su2"], colorName: "イエロー" },
        { name: "b10", color: "rgb(183,200,43)", groups:["sp2"], colorName: "ひわいろ" },
        { name: "b12", color: "rgb(65,184,121)", groups:["sp2"], colorName: "コバルトグリーン" },
        { name: "b14", color: "rgb(0,170,159)", groups:["su2","su4"], colorName: "ピーコックグリーン" },
        { name: "b16", color: "rgb(0,152,185)", groups:["sp2","sp3", "wi2"], colorName: "ターコイズブルー" },
        { name: "b18", color: "rgb(41,129,192)", groups:["su2","su4", "wi2"], colorName: "つゆくさいろ" },
        { name: "b20", color: "rgb(117,116,188)", groups:["sp2","sp3", "su2","su4", "wi2"], colorName: "ウィスタリア" },
        { name: "b22", color: "rgb(161,101,168)", groups:["sp2", "su2","su4", "wi2"], colorName: "あやめいろ" },
        { name: "b24", color: "rgb(208,103,142)", groups:["su2", "wi2"], colorName: "ローズレッド" },
        { name: "dp2", color: "rgb(166,29,57)", groups:["au1"], colorName: "あかねいろ" },
        { name: "dp4", color: "rgb(171,61,29)", groups:["au1","au4"], colorName: "カッパーレッド" },
        { name: "dp6", color: "rgb(177,108,0)", groups:["au1","au4"], colorName: "だいだいいろ" },
        { name: "dp8", color: "rgb(179,147,0)", groups:["au1","au4"], colorName: "からしいろ" },
        { name: "dp10", color: "rgb(116,132,0)", groups:["au1"], colorName: "フォリッジグリーン" },
        { name: "dp12", color: "rgb(0,114,67)", groups:["au1","au4"], colorName: "ときわいろ" },
        { name: "dp14", color: "rgb(0,102,100)", groups:["wi3"], colorName: "かものはいろ" },
        { name: "dp16", color: "rgb(0,84,118)", groups:["au1"], colorName: "なんどいろ" },
        { name: "dp20", color: "rgb(62,51,123)", groups:["wi3"], colorName: "パンジー" },
        { name: "dp22", color: "rgb(97,36,105)", groups:["wi3"], colorName: "ロイヤルパープル" },
        { name: "dp24", color: "rgb(134,29,85)", groups:["wi3"], colorName: "ワインレッド" },
        { name: "lt+2", color: "rgb(241,152,150)", groups:["sp1"], colorName: "さんごいろ" },
        { name: "lt+4", color: "rgb(255,167,135)", groups:["sp1"], colorName: "サーモンピンク" },
        { name: "lt+6", color: "rgb(255,190,113)", groups:["sp1"], colorName: "あんずいろ" },
        { name: "lt+8", color: "rgb(242,217,110)", groups:["sp1", "su1", "wi2","wi4"], colorName: "レモンイエロー" },
        { name: "lt+10", color: "rgb(199,211,109)", groups:["sp1"], colorName: "ひわいろ" },
        { name: "lt+12", color: "rgb(133,206,158)", groups:["sp1"], colorName: "ミントグリーン" },
        { name: "lt+14", color: "rgb(98,192,181)", groups:["su1"], colorName: "せいじいろ" },
        { name: "lt+16", color: "rgb(91,175,196)", groups:["sp1"], colorName: "しんばしいろ" },
        { name: "lt+18", color: "rgb(108,154,197)", groups:["su1"], colorName: "スカイブルー" },
        { name: "lt+20", color: "rgb(144,145,195)", groups:["sp1", "su1"], colorName: "ふじいろ" },
        { name: "lt+22", color: "rgb(176,136,181)", groups:["sp1", "su1"], colorName: "オーキッド" },
        { name: "lt+24", color: "rgb(217,142,165)", groups:["su1"], colorName: "なでしこいろ" },
        { name: "sf2", color: "rgb(202,130,129)", groups:["su3"], colorName: "うすくれない" },
        { name: "sf4", color: "rgb(218,146,122)", groups:["au3","au4"], colorName: "サーモンピンク" },
        { name: "sf6", color: "rgb(219,166,107)", groups:["au3","au4"], colorName: "ゴールデンイエロー" },
        { name: "sf8", color: "rgb(211,189,108)", groups:["au3"], colorName: "ミモザ" },
        { name: "sf10", color: "rgb(173,182,107)", groups:["au3"], colorName: "まっちゃいろ" },
        { name: "sf12", color: "rgb(118,177,138)", groups:["au3"], colorName: "わかなえいろ" },
        { name: "sf14", color: "rgb(84,163,155)", groups:["su3"], colorName: "ターコイズグリーン" },
        { name: "sf16", color: "rgb(81,146,164)", groups:["au3"], colorName: "さびあさぎ" },
        { name: "sf18", color: "rgb(93,126,160)", groups:["su3"], colorName: "ポースリンブルー" },
        { name: "sf20", color: "rgb(120,120,160)", groups:["su3"], colorName: "りんどういろ" },
        { name: "sf22", color: "rgb(144,113,148)", groups:["su3", "au3"], colorName: "はしたいろ" },
        { name: "sf24", color: "rgb(180,120,139)", groups:["su3"], colorName: "オールドローズ" },
        { name: "d2", color: "rgb(163,90,92)", groups:["su3"], colorName: "テラコッタ" },
        { name: "d4", color: "rgb(175,105,84)", groups:["sp4", "au3","au4"], colorName: "かわらけいろ" },
        { name: "d6", color: "rgb(179,127,70)", groups:["sp4", "au3","au4"], colorName: "こはくいろ" },
        { name: "d8", color: "rgb(171,148,70)", groups:["au3","au4"], colorName: "マスタード" },
        { name: "d10", color: "rgb(133,143,70)", groups:["au3"], colorName: "フォリッジグリーン" },
        { name: "d12", color: "rgb(79,135,102)", groups:["au3","au4"], colorName: "ろくしょういろ" },
        { name: "d14", color: "rgb(42,123,118)", groups:["su3"], colorName: "ナイルブルー" },
        { name: "d16", color: "rgb(36,106,125)", groups:["au3"], colorName: "サックスブルー" },
        { name: "d18", color: "rgb(52,89,125)", groups:["su3"], colorName: "アクアマリン" },
        { name: "d20", color: "rgb(84,82,124)", groups:["su3"], colorName: "かちいろ" },
        { name: "d22", color: "rgb(108,74,113)", groups:["su3", "au3"], colorName: "こだいむらさき" },
        { name: "d24", color: "rgb(139,79,101)", groups:["su3"], colorName: "オールドローズ" },
        { name: "dk2", color: "rgb(105,41,52)", groups:["au2"], colorName: "ワインレッド" },
        { name: "dk4", color: "rgb(117,54,42)", groups:["au2"], colorName: "えびちゃ" },
        { name: "dk8", color: "rgb(116,96,31)", groups:["au2"], colorName: "オリーブ" },
        { name: "dk10", color: "rgb(82,91,32)", groups:["au2"], colorName: "モスグリーン" },
        { name: "dk12", color: "rgb(35,82,58)", groups:["au2"], colorName: "ハンターグリーン" },
        { name: "dk14", color: "rgb(0,71,70)", groups:["wi3"], colorName: "ボトルグリーン" },
        { name: "dk22", color: "rgb(67,40,72)", groups:["wi3"], colorName: "しこん" },
        { name: "dk24", color: "rgb(97,45,70)", groups:["wi3"], colorName: "えびいろ" },
        { name: "p+2", color: "rgb(232,194,191)", groups:["sp1"], colorName: "シェルピンク" },
        { name: "p+4", color: "rgb(235,194,181)", groups:["sp1"], colorName: "ネールピンク" },
        { name: "p+6", color: "rgb(244,212,176)", groups:["sp1"], colorName: "レグホーン" },
        { name: "p+8", color: "rgb(242,230,184)", groups:["sp1", "su1", "wi2","wi4"], colorName: "クリームイエロー" },
        { name: "p+10", color: "rgb(216,221,173)", groups:["sp1"], colorName: "びゃくろく" },
        { name: "p+12", color: "rgb(174,212,185)", groups:["sp1"], colorName: "ライムグリーン" },
        { name: "p+14", color: "rgb(166,212,204)", groups:["su1", "wi2","wi4"], colorName: "アイスグリーン" },
        { name: "p+16", color: "rgb(173,209,218)", groups:["sp1"], colorName: "みずいろ" },
        { name: "p+18", color: "rgb(175,192,209)", groups:["su1", "wi2","wi4"], colorName: "フォッグ" },
        { name: "p+20", color: "rgb(187,189,208)", groups:["sp1", "su1", "wi2","wi4"], colorName: "ふじいろ" },
        { name: "p+22", color: "rgb(200,185,201)", groups:["sp1", "su1", "wi2","wi4"], colorName: "ライラック" },
        { name: "PI1", color: "rgb(250,155,165)", groups:["su1","su4", "wi2","wi4"], colorName: "ときいろ" },
        { name: "PI2", color: "rgb(255,139,142)", groups:["su4", "wi2","wi4"], colorName: "ピンク" },
        { name: "PI3", color: "rgb(243,83,130)", groups:["su4", "wi2","wi4"], colorName: "ピンク" },
        { name: "PI4", color: "rgb(200,80,150)", groups:["wi1","wi4"], colorName: "ショッキングピンク" },
        { name: "PI5", color: "rgb(252,188,194)", groups:["sp1"], colorName: "コーラルレッド" },
        { name: "PI6", color: "rgb(244,170,196)", groups:["sp1"], colorName: "こうばいいろ" },
        { name: "PI7", color: "rgb(241,127,154)", groups:["sp2"], colorName: "ももいろ" },
        { name: "PI8", color: "rgb(234,88,119)", groups:["su4"], colorName: "ばらいろ" },
        { name: "PI9", color: "rgb(253,170,137)", groups:["au4"], colorName: "サーモンピンク" },
        { name: "PI10", color: "rgb(250,129,85)", groups:["au4"], colorName: "べにさんご" }
      ],
      msg: "",
      rank: []
    }
  },
  methods: {
    counter() {
      firebase.firestore().collection(`colors`).get().then(snapshot => {
        var array = []
        snapshot.forEach(snap => {
          var data = snap.data()
          array.push({name: data.name, selectedCount: data.selectedCount})
        })
        // selectedCountが大きい順にソート
        array.sort((a, b) => {
          var r = 0
          if (a.selectedCount > b.selectedCount) {
            r = -1
          } else if (a.selectedCount < b.selectedCount) {
            r = 1
          }
          return r
        })
        this.rank = array
      })
    },
    getColorByName(colors, colorName) {
      let color = colors.filter(color => color.name === colorName)[0]
      if (color === undefined) {
        return {name: "", color: "", groups:[], colorName: colorName}
      }
      return color
    }
  }
}
</script>

<style scoped>
.btn {
  height: 50px;
  width: 80px;
}
h3 {
  margin-top: 10px;
  margin-bottom: 0px;
}
table {
  margin-left: auto;
  margin-right: auto;
}
.right {
  text-align: right;
}
.left {
  text-align: left;
}
</style>